import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.GET_LIST_ACCOUNT_PURCHASER.REQUEST, saga.getListAccountPurchaserSaga);
    yield takeLatest(constants.UPDATE_ACCOUNT_PURCHASER.REQUEST, saga.updateAccountPurchaserSaga);
    yield takeLatest(constants.CHANGE_STATUS_ACCOUNT_PURCHASER.REQUEST, saga.changeStatusAccountPurchaserSaga);
    yield takeLatest(constants.CREATE_ACCOUNT_PURCHASER.REQUEST, saga.createAccountPurchaserSaga);
}